import type { StaticLocalizationsSingleLanguageLocalizationsDtoLocalizations } from '@ori/static-api-client-react';

import type { DefaultTranslations } from '../constants';
import { defaultTranslations } from '../constants';

export const parseLocalizations = (
  localizations: StaticLocalizationsSingleLanguageLocalizationsDtoLocalizations & Partial<DefaultTranslations>,
): DefaultTranslations => ({
  update: localizations.update ? localizations.update : defaultTranslations.update,
  updateYourBrowser: localizations.updateYourBrowser
    ? localizations.updateYourBrowser
    : defaultTranslations.updateYourBrowser,
  yourBrowserIsOutdated: localizations.yourBrowserIsOutdated
    ? localizations.yourBrowserIsOutdated
    : defaultTranslations.yourBrowserIsOutdated,
});
